import React from "react";
import { formatRangeVal, getExposure, bookClass, bookText } from "../../casinoComponents/userSiteLastResult/refUtils";
import { RefCard, RefRemark } from "../../casinoComponents/userSiteLastResult/refBits";

// Reference checkLowCards / checkHighCards (page version): A-9 low, 10/J/Q/K high
const isLowCard = (c) => {
  if (String(c) === "1" || !c) return false;
  if (c.length === 3) {
    const t = c.slice(0, 1);
    return t.toLowerCase() === "a" || Number(t) <= 9;
  }
  return false;
};
const isHighCard = (c) => {
  if (String(c) === "1" || !c) return false;
  if (c.length === 3) return ["j", "k", "q"].includes(c.slice(0, 1).toLowerCase());
  return c.length === 4 && c.slice(0, 2) === "10";
};

/**
 * Casino Meter (cmeter) bet area in the reference markup (inside .casino-detail):
 *   .teen1daycasino-container > .teen1dayleft (Low: total + low cards + book/range)
 *   + .teen1daycenter + .teen1dayright (High) — rendered once the feed has cards.
 */
export default function CmeterTable({ raw = {}, exposures = {} }) {
  const sub = Array.isArray(raw?.sub) ? raw.sub : [];
  const main = sub
    .filter((s) => !s?.subtype || s.subtype === "cmeter")
    .sort((a, b) => Number(a?.sr) - Number(b?.sr));
  const cards = String(raw?.card ?? "").split(",");
  const totals = String(raw?.rdesc ?? "").split(",");

  const side = (cls, item, total, test) => {
    const exp = getExposure(exposures, item?.nat);
    return (
      <div className={cls}>
        <div className="text-center">
          <b className="text-playerb">{item?.nat}</b> <span className="text-success ml-2">{total}</span>
        </div>{" "}
        <div className="w-100">
          <div className="casino-cards text-center mt-1">
            {cards.map((c, i) =>
              test(c) ? (
                <div className="casino-card-item" key={i}>
                  <div className="card-image">
                    <RefCard card={c} />
                  </div>
                </div>
              ) : null
            )}
          </div>{" "}
          <div className="casino-min-max">
            <span className={`casino-book ${bookClass(exp)}`}>{bookText(exp)}</span>{" "}
            <span className="float-right">
              R:<span>{formatRangeVal(item?.min)}</span>-<span>{formatRangeVal(item?.max)}</span>
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="teen1daycasino-container">
        {side("teen1dayleft", main[0], totals[0], isLowCard)} <div className="teen1daycenter" />{" "}
        {side("teen1dayright", main[1], totals[1], isHighCard)}
      </div>{" "}
      <RefRemark remark={raw?.remark} />
    </>
  );
}
